var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Press"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('IconBtn',{attrs:{"title":"Add","icon":"mdi-plus"},on:{"click":function($event){return _vm.create()}}})]},proxy:true}])},[_c('Items'),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }